import React from 'react';
import classNames from 'classnames';
import { ODVerticalSplitLayout } from './ODVerticalSplitLayout';
import { ODBreadcrumb } from '../breadcrumb/ODBreadcrumb';
export var ODContentLayout = function (props) {
    var className = props.className, children = props.children;
    var style = {};
    var breadcrumb = props.def.breadcrumb;
    if (!breadcrumb) {
        return (React.createElement("div", { className: classNames('p-2', className), style: style }, children));
    }
    return (React.createElement(ODVerticalSplitLayout, { constraint: "top", height: "45px", flexGrows: [0, 9], className: ['w-full', undefined] },
        React.createElement(ODBreadcrumb, { def: breadcrumb }),
        React.createElement("div", { className: classNames('p-2', className), style: style }, children)));
};
//# sourceMappingURL=ODContentLayout.js.map